<hero-toggle-button [items]="timeUnitsItems"
  (selectItem)="onSelectItem($event)"></hero-toggle-button>